// Authentication service for API calls
import { apiPost, apiPut } from '../utils/apiClient';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  success: boolean;
  message?: string;
  code?: string; // e.g., "PASSWORD_RESET_REQUIRED"
  user?: {
    id: string;
    email: string;
  };
  token?: string; // JWT token
}

export interface UpdatePasswordRequest {
  email: string;
  newPassword: string;
}

export interface UpdatePasswordResponse {
  message: string;
}

// Login user
export const login = async (email: string, password: string): Promise<LoginResponse> => {
  const response = await apiPost(
    `${API_BASE_URL}/auth/login`,
    { email, password }
  );

  const data = await response.json();

  if (!response.ok) {
    // Return the error response which includes the code for password reset
    return data;
  }

  // Token is automatically stored by apiClient
  return data;
};

// Update password
export const updatePassword = async (email: string, newPassword: string): Promise<void> => {
  const response = await apiPut(
    `${API_BASE_URL}/auth/password`,
    { email, newPassword }
  );

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to update password');
  }
};
